const mapAuthorization = (userAuthorize, authorizeList) => {
  if (!userAuthorize.length) return false;
  const matchedAuthorize = userAuthorize.filter((value) =>
    authorizeList.includes(value)
  );
  return matchedAuthorize.length > 0;
};

export default mapAuthorization;
